/**
 * Created by JUNO,Peng on 1/8/2024.
 * Description:
 * SystemConfig model
 * ------ maintenance history ------
 */

export class SystemConfig {
    tssSessionConfig: {
        richClientTimeoutMinutes: number;
        webClientTimeoutMinutes: number;
    };

    tssMessageQueueConfig: {
        openWireHost: string;
        openWirePort: number;
        stompPort: number;
    };

    tssWebSocketConfig: {
        webSocketPort: number;
        webSocketProtocol: string;
    };

    tssTokenConfig: {
        tokenInvalidInterval: number;
        tokenPluginInvalidInterval: number;
        tokenMobileInvalidInterval: number;
    };

    tssNextGenConfig: {
        tamaleProxyURL: string;
        enableSlaask: boolean;

        enableSSO: boolean;
        tamaleIdpURL: string;
        proxyTamaleIdpURL: string;
        tamaleIdpHomeURL: string;
        identityProviderIssuer: string;
        certificate: string;
        proxyIdentityProviderIssuer: string;
        proxyCertificate: string;
    };

    tssClientConfig: {
        contentDeletionWindow: number;
        noteDeletionWindow: number;
        commentDeletionWindow: number;
        filePurgeProtectionWindow: number;
        maxRange: number;
        blurbLength: number;
        showGoToAssist: boolean;
        showFullOffline: boolean;
        clientPasswordManagement: boolean;
        autoLoginAllowed: boolean;
        showTamaleWebLink: boolean;
        tssTickerFormatTypeOverride: any;
        tssRegionTypeOverride: any;
        shortNameFormat: string;
    };

    tssCacheConfig: {
        notificationRefreshMaxSize: number;
        notificationRefreshMessageSize: number;
        maxContentCacheSize: number;

        newsNotificationDeletionWindow: number;
        noteNotificationDeletionWindow: number;
        blastEmailNotificationDeletionWindow: number;
        maxNotificationCacheFileSize: number;
    };

    tssSearchConfig: {
        maxSearchHits: number;
        maxClauseCount: number;
        sortResultsByDate: boolean;
    };

    tssNagiosConfig: {
        nagiosHostname: string;
        nagiosCmdFile: string;
    };

    tssClientServiceConfig: {
        primaryContactName: string;
        primaryContactEmail: string;
        primaryContactMobile: string;
        primaryContactDesk: string;
        secondaryContactName: string;
        secondaryContactEmail: string;
        secondaryContactMobile: string;
        secondaryContactDesk: string;
        generalPhone: string;
        generalEmail: string;
        copyNumber: string;
    };

    tssAdapterConfig: {
        briefingEnabled: boolean;
        hasBriefingEnabled: boolean;
    };

    tssLicenseConfig: {
        hasSeatCount: boolean;
        seatCount: number;
    };

    tssTwmlConfig: {
        isTwmlInvEmailVisible: string;
        twmlTwmUrl: string;
        twmlLpsUrl: string;
        hasIsTwmlInvEmailVisible: string;
        twmlInvEmailSubj: string;
        twmlInvEmailBody: string;
    };

    tssMessageSizeConfig: {
        groupMessageSize: number;
        hasGroupMessageSize: boolean;
    };

    static parse(res): SystemConfig {
        const systemConfig = new SystemConfig();
        systemConfig.tssSessionConfig = res['tssSessionConfig'];
        systemConfig.tssMessageQueueConfig = res['tssMessageQueueConfig'];
        systemConfig.tssWebSocketConfig = res['tssWebSocketConfig'];
        systemConfig.tssTokenConfig = res['tssTokenConfig'];
        systemConfig.tssNextGenConfig = res['tssNextGenConfig'];
        systemConfig.tssClientConfig = res['tssClientConfig'];
        systemConfig.tssCacheConfig = res['tssCacheConfig'];
        systemConfig.tssSearchConfig = res['tssSearchConfig'];
        systemConfig.tssNagiosConfig = res['tssNagiosConfig'];
        systemConfig.tssClientServiceConfig = res['tssClientServiceConfig'];
        systemConfig.tssAdapterConfig = res['tssAdapterConfig'];
        systemConfig.tssLicenseConfig = res['tssLicenseConfig'];
        systemConfig.tssTwmlConfig = res['tssTwmlConfig'];
        systemConfig.tssMessageSizeConfig = res['tssMessageSizeConfig'];

        return systemConfig;
    }
}

export class SystemAction {
    systemAction: string;
}
